import { useMemo } from "react";
import { formatDate } from "@certn/utils";
import { useJsonForms } from "@jsonforms/react";
import { useTranslation } from "react-i18next";
import { Gap } from "../types";

function useGapDateFormat(): string {
  const context = useJsonForms();
  const unit = context?.core?.data?.gap_history?.gap_threshold_unit;
  const useDayPrecision = unit === "DAYS";
  return useDayPrecision ? "MMMM d, yyyy" : "MMMM yyyy";
}

export function useGapTitle(gap: Gap): string {
  const { t } = useTranslation();
  const dateFormat = useGapDateFormat();

  return useMemo(() => {
    const startDate = gap.start_date
      ? formatDate(gap.start_date, dateFormat)
      : "";

    const endDate = gap.end_date
      ? formatDate(gap.end_date, dateFormat)
      : t("Present");

    const dateRange = `${startDate} - ${endDate}`;

    return t("Gap: {{dateRange}}", { dateRange });
  }, [dateFormat, gap.start_date, gap.end_date, t]);
}
